import certificate from '../../assets/playground/certificate.png'
import rushitvideo from '../../assets/playground/youtube.jpg'
export const projectsData = [
  {
    id: 1,
    projectName: "Won a Hackathon",
    liveLink: "",
    hasLink: false,
    img: certificate,
  },
  {
    id: 2,
    projectName: "Session on nextjs.13",
    liveLink: "",
    hasLink: false,
    img: rushitvideo,
  },
 
];
